export class ContactCategory {
    public static ALL = "All Contacts";
    public static FRIENDS = "friends";
    public static WORK = "work";
    public static FAMILY = "family";
    public static OTHERS = "others";
    public static FAVOURITE = "favorite";
}